import React from "react";
import Drawer from '@material-ui/core/Drawer';
import withStyles from "@material-ui/core/styles/withStyles";


const MaintMROFullScreenRightDrawer = withStyles(theme => ({
    paperAnchorRight: {
        width: "calc(100% - 250px)",
        backgroundColor: "#F5F5F5"
    },
    modal:{
        left:'250px !important',
        '& .MuiBackdrop-root':{
            left:'250px'
        }
    }
}))((props) => <Drawer transitionDuration={{enter:800,exit:200}} elevation={0} style={{backgroundColor:"#ffff"}} anchor={"right"} open={true} {...props}>{props.open? props.children:<p style={{backgroundColor:'#fff',height:'100vh'}}/>}</Drawer>)

export default MaintMROFullScreenRightDrawer;